"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = EmptyState;
const react_1 = __importDefault(require("react"));
const reportElementTypes_1 = require("../../../domain/reportElementTypes");
const recoil_1 = require("recoil");
const ReportTypeToggle_1 = require("../shared/ReportTypeToggle");
const EmptyStateBasePage_1 = require("./EmptyStateBasePage");
function EmptyState({ dashboardText, lookText }) {
    const [reportType] = (0, recoil_1.useRecoilState)(ReportTypeToggle_1.reportTypeSwitchState);
    const body = reportType === reportElementTypes_1.ReportElementTypes.Dashboard ? dashboardText : lookText;
    return react_1.default.createElement(EmptyStateBasePage_1.EmptyStateBasePage, { body: body, imgSrc: "/images/empty-state.svg" });
}
